// extracted by mini-css-extract-plugin
export var carousel = "style-module--carousel--78444";
export var image = "style-module--image--424a5";
export var name = "style-module--name--c35d6";
export var price = "style-module--price--0d48f";
export var slide = "style-module--slide--8db46";